import { render, staticRenderFns } from "./DefaultHeaderLanguage.vue?vue&type=template&id=22013b46"
import script from "./DefaultHeaderLanguage.vue?vue&type=script&lang=js"
export * from "./DefaultHeaderLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22013b46')) {
      api.createRecord('22013b46', component.options)
    } else {
      api.reload('22013b46', component.options)
    }
    module.hot.accept("./DefaultHeaderLanguage.vue?vue&type=template&id=22013b46", function () {
      api.rerender('22013b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/views/layouts/partials/DefaultHeaderLanguage.vue"
export default component.exports